import { render, staticRenderFns } from "./LandingButton.vue?vue&type=template&id=275483be&"
import script from "./LandingButton.vue?vue&type=script&lang=js&"
export * from "./LandingButton.vue?vue&type=script&lang=js&"
import style0 from "./LandingButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports